import { render, staticRenderFns } from "./EnableMicAndVideoModal.vue?vue&type=template&id=127e23c8"
import script from "./EnableMicAndVideoModal.vue?vue&type=script&lang=js"
export * from "./EnableMicAndVideoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports